import React from 'react';

const NoTenants: React.FC = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex">
        <div className="w-full text-center">
          <h1 className="page-heading mt-20">Welcome!</h1>
          <p className="max-w-96">
            {
              "We're glad you made it! This service is currently available by invitation only. Please contact a site or organization administrator to be invited."
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoTenants;
